import { styled } from "@mui/material/styles";

export const PrivacyWrapper = styled('section')`
  font-family: 'Inter', sans-serif;
  margin-bottom: 60px;
  padding-top: 50px;

  p {
    font-size: 15px;
    line-height: 27px;
    color: #555;
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 25px;
  }

  a {
    color: ${props => props.theme.customTheme.colors.primary};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;
